import { Injectable } from '@angular/core';
import { GenericResponse } from '../business-entities/generic-response';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service'
import { DealerParkingDetails, DealerParkingImageModel } from '../business-entities/dealer-parking-model';

@Injectable({
    providedIn: 'root'
})

export class DealerParkingDataService {
    constructor(private dataProvider: DataService) {
    }

    async getDealerParkingImage(DealerId: string): Promise<GenericResponse<DealerParkingDetails>> {
        return this.dataProvider.Get<GenericResponse<DealerParkingDetails>>(Urls.GetDealerParkingDetails, DealerId)
            .toPromise();
    }

    addDealerparkingImage(model: DealerParkingImageModel): Promise<any> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.AddDealerParkingImage, model).toPromise();
    }

}